export default __webpack_public_path__ + "static/media/circle-xmark.b6e46a42.svg";